import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ListChecks, ArrowRight } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

/** Schmale Sub-Menü-Leiste unter dem Hauptmenü: offene Onboarding-Aufgaben des Kunden (bis alles erledigt ist). */
export const OnboardingSubBanner = ({ openCount }) => {
  const location = useLocation();
  const [progress, setProgress] = useState(null);

  useEffect(() => {
    if (!openCount) return undefined;
    let alive = true;
    fetch(`${API}/api/onboarding/persons/me`, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
      .then(r => (r.ok ? r.json() : null))
      .then(d => {
        if (!alive || !d) return;
        const open = (d.items || []).filter(it => !it.completed_at && !it.progress?.is_complete);
        const req = open.reduce((s, it) => s + (it.progress?.required_total || 0), 0);
        const done = open.reduce((s, it) => s + (it.progress?.required_done || 0), 0);
        setProgress({ offen: Math.max(req - done, 0), pct: req ? Math.round((done / req) * 100) : 0 });
      })
      .catch(() => {});
    return () => { alive = false; };
  }, [openCount]);

  if (!openCount || location.pathname.startsWith('/portal/onboarding')) return null;
  const offen = progress?.offen ?? null;

  return (
    <div className="bg-brand-navy/[0.04] border-b border-brand-gold/40" data-testid="onboarding-sub-banner">
      <Link to="/portal/onboarding" data-testid="onboarding-sub-banner-link"
        className="max-w-5xl mx-auto px-4 lg:px-6 py-2 flex items-center gap-3 text-sm text-brand-navy hover:bg-brand-navy/[0.04] transition-colors">
        <span className="w-7 h-7 rounded-lg bg-brand-gold/20 text-brand-navy flex items-center justify-center shrink-0">
          <ListChecks className="w-4 h-4" />
        </span>
        <span className="font-semibold whitespace-nowrap">Mein Onboarding</span>
        <span className="hidden sm:block text-gray-500 truncate" data-testid="onboarding-sub-banner-text">
          {offen === null ? 'Ihre Startaufgaben warten auf Sie' : offen === 0 ? 'Nur noch wenige Schritte bis zum Abschluss' : `${offen} offene ${offen === 1 ? 'Aufgabe' : 'Aufgaben'} – gemeinsam bringen wir Ihren Start zu Ende`}
        </span>
        {progress && (
          <span className="hidden md:flex items-center gap-2 ml-auto shrink-0" title={`${progress.pct} % erledigt`}>
            <span className="w-28 h-1.5 rounded-full bg-gray-200 overflow-hidden">
              <span className="block h-full bg-brand-gold rounded-full transition-[width] duration-700" style={{ width: `${progress.pct}%` }} data-testid="onboarding-sub-banner-progress" />
            </span>
            <span className="text-xs text-gray-500 tabular-nums">{progress.pct} %</span>
          </span>
        )}
        <span className={`inline-flex items-center gap-1 text-xs font-bold text-white bg-brand-navy rounded-full px-3 py-1 shrink-0 ${progress ? '' : 'ml-auto'}`}>
          Fortsetzen <ArrowRight className="w-3 h-3" />
        </span>
      </Link>
    </div>
  );
};

export default OnboardingSubBanner;
